export default __webpack_public_path__ + "static/Temp_FrontDesk-917e37f2703b319d78453637127db029.webp";